import React from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";
import styles from "./Header.module.css";
import { auth } from "../firebase-config";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { ReactComponent as Logo1 } from "../assets/DOhorizontal.svg";
import ModalLogOut from "./ModalLogOut";

const Header = () => {
  const { data, userLogout } = React.useContext(UserContext);
  const [modalLogOut, setModalLogOut] = React.useState(false);

  function handleCloseModalConfirm() {
    setModalLogOut(false);
  }
  function handleLogout(event) {
    event.preventDefault();
    userLogout(auth);
  }
  return (
    <header className={`${styles.header}`}>
      <div className={`${styles.containerHeader} container`}>
        <Link className={`${styles.logo}`} to="/">
          <Logo className={`${styles.logoImg}`} />
          <Logo1 />
        </Link>
        {data?.email ? (
          <div className={styles.headerUser}>
            <button
              className={styles.headerUserCircle}
              onClick={() => setModalLogOut(true)}
            >
              {data?.email.slice(0, 2).toUpperCase()}
            </button>
          </div>
        ) : (
          <Link to="/login" className={styles.linkNavHeader}>
            Login
          </Link>
        )}
      </div>
      <ModalLogOut
        isOpen={modalLogOut}
        onRequestClose={handleCloseModalConfirm}
      />
    </header>
  );
};

export default Header;
